import { handleError } from "core/utils/HandleError"
import { handleResponse } from "core/utils/HandleResponse"
import { AuthHttpClient, DefaultHttpClient } from "core/utils/HttpClient"

export function upload(uploadData: FormData) {
  return AuthHttpClient
    .post('/core/upload', uploadData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(handleResponse)
    .catch(handleError)
}

export function multipleupload(uploadData: FormData) {
  return DefaultHttpClient.post('/core/upload/images', uploadData, {
    headers: {'Content-Type': 'multipart/form-data' },
  })
    .then(handleResponse)
    .catch(handleError)
}